// ** React Imports
import { useMemo } from "react";

// ** Redux & Store & Actions
import { useSelector } from "react-redux";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Hooks
import useQuery from "hooks/useQuery";

// #####################################################

const useProfileNameFilterData = () => {
	const { t } = useTranslation(["common", "filtersAndSelectors"]);

	const language = useSelector((state) => state.globalCommon.language);

	const query = useQuery();

	const { nick: nickUrl } = query || {};

	// ** Filtr - Nazwa profilu
	const profileNameFilterData = useMemo(() => {
		return nickUrl
			? {
					label: t("filtersAndSelectors:profilesName"),
					selected: nickUrl,
			  }
			: null;
	}, [nickUrl, language]);

	// #####################################################

	return profileNameFilterData;
};

// #####################################################

export default useProfileNameFilterData;

// #####################################################
